var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRemittanceDeliveryRecipietDownload = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3",
  "data-name": "Group 3",
  transform: "translate(-1307 -530)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2",
  "data-name": "Rectangle 2",
  width: 24,
  height: 24,
  transform: "translate(1307 530)",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "downloading",
  transform: "translate(1310.203 532.152)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M170.489,79.416h1.383c.141,0,.282-.009.421,0a.461.461,0,0,1,.28.721,1.258,1.258,0,0,1-.119.155l-3.624,4.267c-.3.348-.526.349-.82,0L164.387,80.3c-.031-.036-.062-.071-.09-.109a.507.507,0,0,1-.08-.5.376.376,0,0,1,.372-.279h1.76v-.248q0-3.934,0-7.868a1.171,1.171,0,0,1,.327-.913.82.82,0,0,1,.59-.218c.768,0,1.535,0,2.3,0,.569,0,.918.411.92,1.086,0,1.038,0,2.075,0,3.113v4.793C170.489,79.238,170.489,79.314,170.489,79.416Z",
  transform: "translate(-159.621 -69.418)",
  fill: "#3f68b5",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M90.358,349.416h12.387c0-.1,0-.2,0-.29.007-.8-.015-1.594.03-2.386a1.275,1.275,0,1,1,2.544-.074,2.931,2.931,0,0,1,.026.4q0,1.911,0,3.821c0,1.065-.541,1.729-1.409,1.729q-7.385,0-14.769,0c-.871,0-1.411-.661-1.413-1.725,0-1.3-.006-2.6,0-3.893.007-1.177.865-1.929,1.752-1.548a1.658,1.658,0,0,1,.848,1.588c0,.7,0,1.4,0,2.1C90.358,349.23,90.358,349.316,90.358,349.416Z",
  transform: "translate(-87.754 -332.926)",
  fill: "#3f68b5",
  fillRule: "evenodd"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRemittanceDeliveryRecipietDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/RemittanceDeliveryRecipietDownload.c472e00e6c27fa31a9a20cd3da322e76.svg";